import React, { useState } from "react";
import { withCookies } from "react-cookie";
import config from "cfg/config";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import * as WebUtils from "utils/WebUtils";
import { withRouter } from "react-router-dom";

const drawerWidth = 280;

import { withStyles } from "@material-ui/core/styles";

import { loadingOrg } from "redux/selectors/user.selector";
// Actions
import {
    toggleSidenav,
    toggleOrganizations
} from "redux/actions/layout.actions";
import MenuSidenavCompact from "layouts/components/menu-sidenav-compact/menu-sidenav-compact.component";
import { orgConfig } from "redux/selectors";

const Sidenav = (props) => {
    const {
        layout,
        classes,
        cookies,
        siteType,
        acEnabled,
        acOrgId,
        acTimeZone,
        rrEnabled,
        rrOrgId,
        acSegregateByBusinessEntity,
        isDemoSite,
        orgConfigs,
        ...rest
    } = props;

    return (
        <>
            {/* main menu */}
            <MenuSidenavCompact {...rest} id={"menu"} />
        </>
    );
};

function mapStateToProps(state) {
    const orgConfigs = orgConfig(state);
    const siteTypeConfig =
        orgConfigs && orgConfigs.find((oc) => oc.id == "site/type");
    const acEnabledConfig =
        orgConfigs && orgConfigs.find((oc) => oc.id == "ac/enabled");
    const acOrgIdConfig =
        orgConfigs && orgConfigs.find((oc) => oc.id == "ac/orgId");
    const acTimeZoneConfig =
        orgConfigs && orgConfigs.find((oc) => oc.id === "ac/timezone");
    const acSegregateByBusinessEntityConfig =
        orgConfigs &&
        orgConfigs.find((oc) => oc.id == "ac/segregateByBusinessEntity");
    const demoSiteConfig =
        orgConfigs && orgConfigs.find((oc) => oc.id === "ac/demoSite");
    const isDemoSite = (demoSiteConfig && demoSiteConfig.value) || false;
    const siteType = siteTypeConfig && siteTypeConfig.value;
    const acEnabled = (acEnabledConfig && acEnabledConfig.value) || false;
    const acOrgId = acOrgIdConfig && acOrgIdConfig.value;
    const acTimeZone = acTimeZoneConfig && acTimeZoneConfig.value;
    const acSegregateByBusinessEntity =
        (acSegregateByBusinessEntityConfig &&
            acSegregateByBusinessEntityConfig.value) ||
        false;

    const rrEnabledConfig =
        orgConfigs && orgConfigs.find((oc) => oc.id == "revrec/enabled");
    const rrOrgIdConfig =
        orgConfigs && orgConfigs.find((oc) => oc.id == "revrec/orgId");
    const rrEnabled = rrEnabledConfig ? rrEnabledConfig.value : true;
    const rrOrgId = rrOrgIdConfig && rrOrgIdConfig.value;

    return {
        theme: state.theme,
        siteType,
        acEnabled,
        acOrgId,
        acTimeZone,
        rrEnabled,
        rrOrgId,
        acSegregateByBusinessEntity,
        layout: {
            sidenavOpen: state.layout.sidenavOpen
        },
        loadingOrg: loadingOrg(state),
        isDemoSite,
        orgConfigs
    };
}

Sidenav.propTypes = {
    toggleSidenav: PropTypes.func.isRequired
};

const styles = (theme) => ({
    appButtonOverrides: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: theme.palette.background.button.main,
        borderRadius: 8,
        height: 53,
        width: "100%",
        marginBottom: theme.spacing(1)
    },

    buttonClosedRootOverrides: {
        backgroundColor: theme.palette.background.button.main,
        justifyContent: "space-between",
        padding: 6,
        height: 53,
        borderRadius: 8,
        color: "white",
        width: "100%",
        "&:hover": {
            background: theme.palette.background.button.main
        },
        marginBottom: 20
    },
    buttonOpenRootOverrides: {
        backgroundColor: theme.palette.background.button.main,
        justifyContent: "space-between",
        padding: 12,
        borderRadius: 0,
        color: "white",
        width: "100%",
        "&:hover": {
            background: theme.palette.background.button.main
        }
    },
    menuItemTitle: {
        fontSize: "0.9rem",
        paddingRight: "12px",
        color: "rgb(77, 82, 102)"
    },
    orgSidebar: {
        backgroundColor: "white",
        overflow: "auto",
        height: "100%",

        "& .MuiListItem-container": {
            "&:nth-child(even)": {
                background: "#f8f8f8"
            },
            "&:hover": {
                background: "#eeeeee"
            }
        }
    },
    divider: {
        marginTop: 8
    },
    toolBarGutterOverrides: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        transition: theme.transitions.create("padding", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        })
    },
    toolBarGutterOverridesOpen: {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        marginTop: -1,
        transition: theme.transitions.create("padding", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        })
    },
    entityToolBarGutterOverrides: {
        marginTop: theme.spacing(0),
        marginBottom: theme.spacing(0),
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        transition: theme.transitions.create("padding", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        })
    },
    drawerOverride: {
        borderTopRightRadius: theme.spacing(1),
        borderBottomRightRadius: theme.spacing(1),
        backgroundColor: theme.palette.background.default
    },
    sideNav: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: "nowrap"
    },
    sideNavOpen: {
        width: 260,
        overflow: "hidden",
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        }),
        borderTopRightRadius: theme.spacing(0),
        borderTopLeftRadius: theme.spacing(0),
        boxShadow: `1px 0 2px 0 rgba(0,0,40,.08), 6px 0 10px 0 rgba(0,0,40,.08)`
    },
    sideNavDocked: {
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        overflowX: "hidden",
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up("sm")]: {
            width: theme.spacing(7.2) + 1
        },
        color: "#fff",
        overflow: "hidden",
        background: theme.palette.primary.main,
        boxShadow: `1px 0 2px 0 rgba(0,0,40,.08), 6px 0 10px 0 rgba(0,0,40,.08)`,
        "& header": {
            backgroundColor: theme.palette.primary.main,
            "& .MuiPaper-root": {
                "& .MuiToolbar-root": {
                    "& .MuiListItem-button": {
                        paddingLeft: "9px",
                        width: "5px!important",
                        "& .MuiListItemIcon-root": {
                            background: "transparent",
                            minWidth: "24px",
                            padding: "8px",
                            marginRight: "15px",
                            borderRadius: "5px",
                            "&:hover": {
                                backgroundColor: theme.palette.primary[300]
                            }
                        }
                    },
                    "& .MuiIconButton-root": {
                        "& svg": {
                            fill: "#fff"
                        },
                        "&:hover": {
                            color: theme.palette.background.neutral[200]
                            // backgroundColor: `${theme.palette.primary[300]} !important`
                        }
                    },
                    "& .MuiToolbar-root": {
                        "& .MuiBox-root": {
                            width: "58px",
                            background: theme.palette.primary.main
                        }
                    },
                    background: theme.palette.primary.main,
                    overflow: "hidden"
                }
            }
        },
        "& .MuiSvgIcon-root": {
            fill: "#eaeaf4",
            opacity: 0.6
        },

        "& .MuiListItemIcon-root": {
            marginRight: "40px"
        },

        "& .setMenuActive": {
            fontWeight: 600,
            color: theme.palette.primary.main,
            backgroundColor: "rgb(234, 234, 244)",
            "& .MuiSvgIcon-root": {
                fill: theme.palette.background.neutral[600]
            }
        },
        "& .MuiListItem-button": {
            "&:hover": {
                background: theme.palette.primary[300],
                borderRadius: "5px",
                "& .MuiSvgIcon-root": {
                    fill: "#ffffff",
                    opacity: 1
                },
                "& .MuiTypography-body1": {
                    color: "#ffffff"
                }
            }
            // backgroundColor: '#782ca8',
            // borderRadius: '5px'
        },
        "& #menu": {
            "&>div:first-child": {
                overflowX: "hidden"
            }
        },
        "& .MuiBox-root": {
            overflowX: "hidden",
            "& #my-account": {
                paddingLeft: 13,
                paddingRight: 10,
                width: "50px !important",
                marginLeft: 4
            },
            "& #help": {
                paddingLeft: "3px",
                paddingRight: "6px",
                "& .MuiButtonBase-root": {
                    paddingLeft: "13px"
                }
            },
            "& #productSwitcher": {
                paddingLeft: "3px",
                paddingRight: "6px",
                "& .MuiButtonBase-root": {
                    paddingLeft: "13px"
                }
            }
        }
    },
    dropDownMenuPrimary: {
        width: "100%",
        cursor: "pointer",
        "&:hover": {}
    },
    dpIcon: {
        width: "1em !important",
        height: "1em !important"
    },
    dpTextContainer: {
        display: "flex",
        flexDirection: "column"
    },
    logo: {
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
        height: "27px"
    },
    orgTitleSidenav: {
        whiteSpace: "nowrap",
        overflow: "hidden !important",
        textOverflow: "ellipsis",
        textTransform: "none",
        width: "145px",
        paddingRight: 16,
        fontWeight: 600
    },
    orgTitle: {
        color: "inherit",
        fontSize: 14,
        fontWeight: 500
    },
    dpSubtitle: {
        color: theme.palette.background.neutral[500],
        fontSize: 12,
        textTransform: "capitalize"
    },
    avatar: {
        width: theme.spacing(3),
        height: theme.spacing(3)
    },
    impersonation: {
        display: "flex"
    },
    listItemText: {
        flex: "1 1 100%",
        textTransform: "none",
        fontSize: 14,
        fontWeight: 400,
        lineHeight: 1.75,
        color: theme.palette.background.neutral[600],
        "&hover": {
            color: theme.palette.background.neutral[600],
            fontWeight: 600
        }
    },
    listIcon: {
        height: "24px",
        color: theme.palette.background.neutral[600],
        "&hover": {
            color: theme.palette.background.neutral[600]
        }
    },
    listItemIconOverrides: {
        color: theme.palette.background.neutral[600],
        minWidth: theme.spacing(4),
        height: theme.spacing(3)
    },
    bottomListItemIconOverrides: {
        justifyContent: "center",
        color: theme.palette.background.neutral[600],
        minWidth: theme.spacing(3),
        height: theme.spacing(3),
        marginRight: theme.spacing(2)
    },
    listItemGuttersOverrides: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1)
    },
    listItemRootOverrides: {
        padding: 0,
        borderRadius: theme.spacing(1),
        paddingLeft: theme.spacing(1),
        marginLeft: theme.spacing(1),
        paddingTop: 1,
        paddingBottom: 3
    },
    bottomListItemRootOverrides: {
        borderRadius: theme.spacing(1),
        padding: "1px 8px"
    },
    popover: {
        marginLeft: theme.spacing(-1)
    },
    ptb0: {
        paddingTop: 0,
        paddingBottom: 0
    },
    orgSwitcher: {
        marginBottom: 15
    },
    activeChip: {
        height: "22px",
        fontWeight: 500,
        fontSize: "12px",
        borderRadius: "4px",
        // borderColor: theme.palette.background.green[600],
        color: theme.palette.background.green[600],
        backgroundColor: theme.palette.background.green[100]
    },
    errorChip: {
        height: "22px",
        fontWeight: 500,
        fontSize: "12px",
        borderRadius: "4px",
        // borderColor: theme.palette.background.red[600],
        color: theme.palette.background.red[600],
        backgroundColor: theme.palette.background.red[100]
    },
    warningChip: {
        height: "22px",
        fontWeight: 500,
        fontSize: "12px",
        borderRadius: "4px",
        // borderColor: theme.palette.background.orange[600],
        color: theme.palette.background.orange[600],
        backgroundColor: theme.palette.background.orange[100]
    },
    icon: {
        color: "#757575",
        marginRight: "-27px"
    },
    helpBox: {
        backgroundColor: "white",
        color: "#4d5266",
        cursor: "pointer",
        opacity: "1"
    },
    productSwitcher: {
        backgroundColor: "white",
        color: "#4d5266",
        cursor: "pointer",
        opacity: "1"
    }
});

export default WebUtils.compose(
    withRouter,
    withCookies,
    connect(mapStateToProps, {
        toggleSidenav,
        toggleOrganizations
    }),
    withStyles(styles, { withTheme: true })
)(Sidenav);
